"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncompatibleWith = exports.incompatibleWith = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const Exists_1 = require("./Exists");
const hasValues = (val) => {
    if ((0, isObject_1.default)(val)) {
        return !(0, isEmpty_1.default)(val);
    }
    if (typeof val === "string") {
        return !!val;
    }
    return !(0, isNil_1.default)(val);
};
async function incompatibleWith(value, args, constraints) {
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: true,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    // validate that listed siblings are empty if this object's value is not empty
    if (hasValues(value) && (constraints === null || constraints === void 0 ? void 0 : constraints.siblings)) {
        const nonEmptySiblings = constraints.siblings.filter((sibling) => hasValues(args.object[sibling]));
        if (nonEmptySiblings.length !== 0) {
            return { pass: false, message: `cannot exist alongside the following properties: ${nonEmptySiblings}` };
        }
    }
    return { pass: true };
}
exports.incompatibleWith = incompatibleWith;
/**
 * Validates that this field is empty if other properties defined in `siblings` are not empty.
 * NOTE: 'is empty' is according to `LoDash.isEmpty`'s definition of empty.
 */
function IncompatibleWith(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IncompatibleWith",
        defaultMessage: "cannot exist alongside certain other properties",
        options,
        constraints,
        validateFn: incompatibleWith,
    });
}
exports.IncompatibleWith = IncompatibleWith;
//# sourceMappingURL=IncompatibleWith.js.map